'use strict';

angular.module('buyers')
.directive('propertyEnquiry', ['$rootScope', 'BuyerService', function($rootScope, BuyerService) {
    return {
        templateUrl : "partials/property-enquiry.html",
        restrict: 'E', // attribute
        scope: {
            'back': '&onBack',
            'send': '&onSend',
            'property':'='
        },
        link : function (scope, element, attrs) {
            var currentUser = $rootScope.currentUser;
            scope.enquiry = {
                name: currentUser.name,
                email: currentUser.info.email,
                phone: currentUser.info.mobile,
                aboutBuyer: '',
                buyerLikes: [],
            };
            element.find('.buyer-likes').on('click', function(){
                var val = $(this).find('input').val();
                var index = scope.enquiry.buyerLikes.indexOf(val);
                if($(this).find('input:checked').length > 0 && index < 0) {
                    scope.enquiry.buyerLikes.push(val);
                } else if(index > -1) {
                    scope.enquiry.buyerLikes.splice(index,1);    
                }
            });

            element.find('.send-enquiry').on('click', function(){
                $rootScope.loading = true;
                BuyerService.sendEnquiry(scope.enquiry, scope.property)
                .then(function(data){
                    alert('Your enquiry has been sent to agent.');
                })
                .catch(function(err){
                    console.log(err);
                })
                .finally(function(data){
                    $rootScope.loading = false;
                });
            });
        }
    };
}]);